module.exports = __webpack_public_path__ + "static/img/wap.b56f130.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/长城书院/wap.svg
// module id = 0j6I
// module chunks = 16